import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { reportTypes } from './reportConstants';

const AdvancedReportTypesCard = () => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle>{t('reportsComp.typesTitle')}</CardTitle>
      <CardDescription>{t('reportsComp.typesSubtitle')}</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {reportTypes.map((reportType) => {
          const IconComponent = reportType.icon;
          return (
            <Card key={reportType.id} className="cursor-pointer hover:bg-accent/50 transition-colors">
              <CardContent className="p-4">
                <div className="flex items-start space-x-3">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <IconComponent className="h-5 w-5 text-primary" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-sm">{t(reportType.nameKey)}</h3>
                    <p className="text-xs text-muted-foreground mt-1">{t(reportType.descKey)}</p>
                    <Badge variant="secondary" className="mt-2 text-xs">{t(reportType.categoryKey)}</Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </CardContent>
  </Card>
  );
};

export default AdvancedReportTypesCard;
